import { observable, action, runInAction, computed } from 'mobx'
import { message } from 'antd'
import { json, get } from '../../../../utils/ajax'
import {setStore} from "../../../../utils/Utils";

class HoursCatalogManagerStore {

    @observable loading
    @observable carseriesCatalogList
    @observable pagination
    @observable brands
    @observable carSeries
    @observable modal
    @observable brandId
    @observable carSeriesId
    @observable modalCatalog
    @observable tree
    @observable carseriesId
    @observable editFields
    @observable info
    @observable option
    @observable carseries//用于车系下拉框
    @observable oldCarId//用于存放老车系ID
    @observable newCarId//用于存放新车系ID
    @observable oldCarCatalog//用于存放老车系目录
    @observable oldCarCatalogID//用于存放老车系目录ID
    @observable newCarCatalog//用于存放新车系目录
    @observable newCarCatalogID//用于存放新车系目录ID
    @observable modalCatalogCopy//显示目录复制
    @observable modalCarCopy//显示车系目录
    @observable oldCarCatalogLevel//用于存放老车系目录层级
    @observable newCarCatalogLevel//用于存放新车系目录层级
    @observable editCatalogloading
    @observable rowData
    @observable dragList
    @observable expandedLeftRowKeys
    @observable dragState //是否显示拖拽后保存按钮
    @observable tabPagesCarseriesId  //点击查看目录需要的参数id
    @observable tabPagesCarseriesName //点击查看目录需要的参数名字

    constructor () {
        this.loading = false
        this.carseriesCatalogList = []
        this.pagination = {}
        this.brands = {
            list: [],
            selected: ''
        }
        this.carSeries = {
            list: [],
            selected: ''
        }
        this.modal = 'hide'
        this.brandId = []
        this.carSeriesId = []
        this.modalCatalog = 'hide'
        this.tree = []
        this.carseriesId = []
        this.editFields = {}
        this.info = []
        this.option = []
        this.carseries = []
        this.oldCarId = ''
        this.newCarId = ''
        this.oldCarCatalog = []
        this.oldCarCatalogID = ''
        this.newCarCatalog = []
        this.newCarCatalogID = ''
        this.modalCatalogCopy = false
        this.modalCarCopy = false
        this.oldCarCatalogLevel = ''
        this.newCarCatalogLevel = ''
        this.editCatalogloading = false
        this.rowData = {}
        this.dragList = []
        this.expandedLeftRowKeys = []
        this.dragState = false
        this.tabPagesCarseriesId = ''
        this.tabPagesCarseriesName = ''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 初始化页面
     */
    @action
    initListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/carseriesCatalog/list`, {
            page: page,
            size: 10
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carseriesCatalogList = res.content
            this.pagination = {
                results: res.size,
                page: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })
    }

    /**
     * 初始化品牌下拉框
     */
    @action
    initBrands = async () => {
        runInAction(() => {
            this.loading = true
            this.brands = {
                list: [],
                selected: ''
            }
            this.carSeries = {
                list: [],
                selected: ''
            }
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/brand:brandList`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.brands.list = res
            this.loading = false
            this.modal = 'show'
        })
    }

    /**
     * 初始化车系下拉框
     */
    @action
    initCarseries = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/carseries/list/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carSeries.list = res
            this.loading = false
        })
    }

    /**
     * 选中品牌
     */
    @action
    saveBrandId = (value) => {
        runInAction(() => {
            this.brandId = value
        })
    }

    /**
     * 选中车系
     */
    @action
    saveCarSeriesId = (value) => {
        runInAction(() => {
            this.carSeriesId = value
        })
    }

    /**
     * 保存选中的车系和品牌记录
     */
    @action
    saveCatalog = async () => {
        runInAction(() => {
            this.loading = true
        })
        //If NUll
        if (this.brandId.length === 0 || this.carSeriesId.length === 0) {
            message.warning('请选择品牌和车系')
            return
        }
        //获取品牌信息
        let brand = []
        const brandList = this.brands.list
        for (let i = 0; i < brandList.length; i++) {
            if (brandList[i].id === this.brandId) {
                brand = brandList[i]
            }
        }
        //获取车系信息
        let carSeries = []
        const carSeriesList = this.carSeries.list
        for (let i = 0; i < carSeriesList.length; i++) {
            if (carSeriesList[i].id === this.carSeriesId) {
                carSeries = carSeriesList[i]
            }
        }
        //构造
        const data = {
            'carseriesName': carSeries.defaultName,
            'carseriesImage': carSeries.icon,
            'carseriesId': carSeries.id,
            'rank': carSeries.rank,
            'brandName': brand.defaultName,
            'brandId': brand.id,
            'state': 0
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/carseriesCatalog/add`, data)
        runInAction(() => {
            if(res.status===1){
                if(res.data==='新增成功'){
                    message.success(res.data)
                }else {
                    message.warning(res.data)
                }
            }
            this.loading = false
            this.modal = 'hide'
        })
        this.initListPage(this.pagination.current)
    }

    /**
     *取消编辑
     */
    @action
    cancelEdit () {
        this.loading = false
        this.modal = 'hide'
    }

    /**
     * 发布/撤销
     */
    @action
    publishByCarseriesId= async (rocord) => {
        runInAction(() => {
            this.loading = true
        })
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/list?carseriesId=${rocord.carseriesId}`)
        if(res1.length === 0){
            message.warning('该车系下没有目录，请先添加目录！');
            runInAction(() => {
                this.loading = false
            })
            return
        }
        let state = rocord.state ? 0 : 1;
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/carseriesCatalog/id/${rocord.id}/state/${state}`)
        if (res && res.status === 0) {
            message.error('发布失败！');
            return
        }
        if(state === 1){
            message.success('发布成功！');
        }else{
            message.success('撤销成功！');
        }
        runInAction(() => {
            this.loading = false
        })
        this.initListPage(this.pagination.current)
    }

    /**
     *清空目录
     */
    @action
    clearEditPage () {
        runInAction(() => {
            this.modalCatalog = 'hide'
            this.tree = []
        })
    }

    /**
     *初始化目录树表
     */
    @action
    initEditPage = async (carseriesId) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/list?carseriesId=${carseriesId}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.tree = res
            let initList=[]
            res.map(item=>{
                initList.push({...item,children:''})
            })
            this.dragList=Array.isArray(res)?initList:[]
            this.carseriesId = carseriesId
        })
    }

    /**
     * 显示
     */
    @action
    showBox = (record, option) => {
        if(option === 'update'){
            runInAction(()=>{
                this.editFields.name = record.name
                this.editFields.numbered = record.numbered
            })
        }else{
            runInAction(()=>{
                this.editFields.name = ''
                this.editFields.numbered = ''
            })
        }
        runInAction(() => {
            this.loading = true
            this.info = record
            this.option = option
            this.modalCatalog = 'show'
            this.loading = false
        })
    }

    /**
     *显示1级输入框
     */
    @action
    showAddFirstBox = () => {
        runInAction(() => {
            this.option="addFrist"
            this.loading = true
            this.editFields.content = ''
            this.modalCatalog = 'show'
            this.loading = false
        })
    }

    //关闭
    @action
    closeBox = () => {
        this.modalCatalog = 'hide'
        this.editFields={}
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onEditFieldChange (changedFields) {
        const fields = {...this.fields, ...changedFields}
        let editFields = {
            name: fields.name.value,
            numbered: fields.numbered.value,
        }
        this.editFields = editFields
    }

    /**
     * 平行化表单，传值给form
     */
    @computed
    get fields () {
        let fields = {
            name: {value: this.editFields.name},
            numbered: {value: this.editFields.numbered},
        }
        return fields
    }

    /**
     * 新增一级目录
     * 新增同级目录
     * 新增下级目录
     * 修改目录
     */
    @action
    operation = async (content, info, option) => {
        //新增一级
        runInAction(() => {
            this.loading = true
            this.editFields.name = ''
            this.editFields.numbered = ''
        })
        let data = {
            'carseriesId': this.carseriesId,
            'name': content.name,
            'numbered':content.numbered,
        }
        if(option === 'update'){
            data.id=info.id
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/update`, data)
        }else  {
            if (option === 'addSame') {
                data.level=info.level
                data.pId=info.pId
            } else if (option === 'addChild') {
                data.level=info.level+1
                data.pId=info.id
            }else {//addFirt
                data.level=1
                data.pId=0
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/create`, data)
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/list?carseriesId=${this.carseriesId}`)
        runInAction(() => {
            this.tree = res
            let initList=[]
            res.map(item=>{
                initList.push({...item,children:''})
            })
            this.rowData.id?this.clickRow(this.rowData):this.dragList=Array.isArray(res)?initList:[]
            this.loading= false
            this.modalCatalog = 'hide'
        })
    }

    /**
     * 删除目录
     */
    @action
    deleteOne = async (record) => {
        runInAction(() => {
            this.loading = true
        })
        await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/delete?id=${record.id}`)
        message.success('删除成功')
        if(this.tree.slice().length === 1){
            let state = 0
            const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/carseriesCatalog/id/${record.carseriesId}`)
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/carseriesCatalog/id/${res1.id}/state/${state}`)
        }
        runInAction(() => {
            this.loading = false
        })
        this.initEditPage(record.carseriesId)
    }

    /**
     * 上移
     */
    @action
    shiftUp = async(record) => {
        runInAction(() => {
            this.loading = true
        })
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/shiftUp?pId=${record.pId}&id=${record.id}`)
        runInAction(() => {
            this.loading = false
        })
        await this.initEditPage(record.carseriesId)
    }

    /**
     * 下移
     */
    @action
    moveDown = async(record) => {
        runInAction(() => {
            this.loading = true
        })
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/moveDown?pId=${record.pId}&id=${record.id}`)
        runInAction(() => {
            this.loading = false
        })
        await this.initEditPage(record.carseriesId)
    }

    /***
     * 删除
     * @param rocord
     * @returns {Promise<void>}
     */
    @action
    deleteByCarseriesId = async (rocord) => {
        const res = await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/carseriesCatalog/deleteCarseriesCatalog?id=` + rocord.id + '&&carseriesId=' + rocord.carseriesId)
        if (res && res.status === 0) {
            return
        }
        this.initListPage(this.pagination.current)
    }

    /**
     * 初始化车系
     */
    @action initCarseriesList = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/carseriesCatalog/list`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carseries = res.content
        })
    }

    /**
     * 显示目录复制
     */
    showCatalogCopy = () => {
        this.oldCarId = ''
        this.newCarId = ''
        this.oldCarCatalog = []
        this.newCarCatalog = []
        this.carseries = []
        this.modalCatalogCopy = true
    }

    /**
     * 显示车系复制
     */
    showCarCopy = () => {
        this.oldCarId = ''
        this.newCarId = ''
        this.modalCarCopy = true
    }

    /**
     * 取老车系ID
     */
    @action oldCar = (value) => {
        this.oldCarId = value;
    }

    /**
     * 取新车系ID
     */
    @action newCar = (value) => {
        this.newCarId = value;
    }

    /**
     * 老车系目录树
     */
    @action
    initOldCarDirectory = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/list?carseriesId=${this.oldCarId}`)
        if (res.length === 0) {
            message.warning('该车系没有目录！')
            runInAction(() => {
                this.oldCarCatalog = [];
            })
            return
        }
        runInAction(() => {
            this.oldCarCatalog = res
        })
    }

    /**
     * 新车系目录树
     */
    @action
    initNewCarDirectory = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/list?carseriesId=${this.newCarId}`)
        if (res.length === 0) {
            runInAction(() => {
                this.newCarCatalog = [];
            })
            return
        }else {
            message.warning('该车系已存在目录！')
        }
        runInAction(() => {
            this.newCarCatalog = res
            let data = this.carseries.find(item=>item.carseriesId===this.newCarId)
            if(data&&data.copyStatus===1){
                this.rightSelectCarId = ''
                message.warning(`车系正在复制中!`)
            }
        })
    }

    /**
     * 新车系目录树
     */
    @action
    initNewCarCatalogDirectory = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/list?carseriesId=${this.newCarId}`)
        if (res.length === 0) {
            runInAction(() => {
                this.newCarCatalog = [];
            })
            return
        }
        runInAction(() => {
            this.newCarCatalog = res
            let data = this.carseries.find(item=>item.carseriesId===this.newCarId)
            if(data&&data.copyStatus===1){
                this.rightSelectCarId = ''
                message.warning(`车系正在复制中!`)
            }
        })
    }

    /**
     * 车系复制
     */
    @action carCopy = async () => {
        this.editCarloading=true
        if (this.oldCarId !== '' && this.newCarId !== '') {
            if(this.newCarCatalog.length > 0){
                message.warning('该车系下已有目录！')
                runInAction(() => {
                    this.loading = false
                })
                return
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/carseriesCatalog/copyStatus/id/${this.newCarId}`)
            await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/copy?originalCarId=${this.oldCarId}&newCarId=${this.newCarId}&originalCatalogId=${this.oldCarCatalogID}&newCatalogId=${this.newCarCatalogID}`)
        } else {
            message.warning('请选择新老车系！')
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.editCarloading=false
            this.initListPage(this.pagination.current)
            message.warning(`车系正在复制中，请勿操作！`)
            this.oldCarId = ''
            this.newCarId = ''
            this.oldCarCatalog = []
            this.newCarCatalog = []
            this.carseries = []
            this.modalCarCopy = false
        })
    }

    //关闭
    @action
    submitCopyCar = () => {
        this.modalCatalogCopy = false
        this.modalCarCopy = false
        this.oldCarId = ''
        this.oldCarCatalogID = ''
        this.newCarId = ''
        this.newCarCatalogID = ''
        this.newCarCatalogLevel=''
        this.oldCarCatalog = []
        this.newCarCatalog = []
        this.carseries = []
    }

    /**
     * 清空老车系目录
     */
    @action emptyOldCarCatalog = () => {
        this.oldCarCatalog = []
    }

    /**
     * 清空新车系目录
     */
    @action emptyNewCarCatalog = () => {
        this.newCarCatalog = []
    }

    /**
     * 获取老车系目录树ID
     */
    @action getTheOldCarCatalogTreeID = (directoryId,level) => {
        this.oldCarCatalogID = directoryId[0]
        if(directoryId.length===0){
            this.oldCarCatalogLevel = ''
        }else {
            this.oldCarCatalogLevel = level
        }
    }

    /**
     * 获取新车系目录树ID
     */
    @action getTheNewCarCatalogTreeID = (directoryId,level) => {
        this.newCarCatalogID = directoryId[0]
        if(directoryId.length===0){
            this.newCarCatalogLevel = ''
        }else {
            this.newCarCatalogLevel = level
        }
    }

    /**
     * 目录复制
     */
    @action catalogCopy = async () => {
        this.editCatalogloading=true
        if (this.oldCarCatalogID !== ''&& this.oldCarId !== '' && this.newCarId !== '') {
            if (this.oldCarCatalogLevel===this.newCarCatalogLevel+1||(this.oldCarCatalogLevel===1&&!this.newCarCatalogLevel)){
                await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/copy?originalCarId=${this.oldCarId}&newCarId=${this.newCarId}&originalCatalogId=${this.oldCarCatalogID}&newCatalogId=${this.newCarCatalogID}`)
            } else {
                message.warning('选择新老车系目录层级不正确，请检查！')
                runInAction(() => {
                    this.loading = false
                    this.editCatalogloading=false
                })
                return
            }
        } else {
            message.warning('请选择新老车系目录！')
            runInAction(() => {
                this.editCatalogloading=false
            })
            return
        }
        runInAction(() => {
            this.editCatalogloading = false
            this.oldCarId = ''
            this.oldCarCatalogID = ''
            this.newCarId = ''
            this.newCarCatalogID = ''
            this.oldCarCatalog = []
            this.newCarCatalog = []
            this.carseries = []
            this.modalCatalogCopy = false
            this.newCarCatalogLevel=''
            this.initListPage(this.pagination.current)
        })
    }

    /***
     * 点击左边目录树显示右边数据
     */
    /****
     * 点击行数据
     */
    @action
    clickRow=async (record)=>{
        this.rowData=record
        if(!record.children){
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/id/${record.id}`)
            runInAction(()=>{
                this.dragList=[res]
            })
        }else {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/querySubordinateDirectoriesByDirectoryId/${record.id}`)
            runInAction(()=>{
                this.dragList=Array.isArray(res)?res:[]
            })
        }
    }

    /**
     * 展开的行变化时触发
     * @param expandedRows
     */
    @action
    changeExpandedLeftRowKeys=(expandedRows)=>{
        this.expandedLeftRowKeys = expandedRows
    }

    /***
     * 保存排序
     * @returns {Promise<void>}
     */
    @action
    saveSort=async ()=>{
        let dragList = []
        this.dragList.forEach((item, index) => {
            dragList.push({
                id: item.id,
                sort: index + 1
            })
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/modifySort`,dragList)
        if (res && res.status === 0) {
            return
        }
        runInAction(()=>{
            this.dragState=false
        })
        await this.initEditPage(this.carseriesId)
        this.rowData.id&&await this.clickRow(this.rowData)
    }
}
export default new HoursCatalogManagerStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/HoursManual/HoursCatalogManager/store.js